<template>
  <div class="container page" style="width: 100%;height: 100%;background: url(/img/home/g.f7e76bcc.png) repeat top / 100% auto;">
    <van-nav-bar :title="$t('setting.bank_info')" class="nav-bar">
      <template #left>
        <van-icon name="arrow-left" color="#000" @click="back()"/>
      </template>
    </van-nav-bar><div style="width: 90%;
    background: linear-gradient(90deg, #ee392f, #f4562a);
    border-radius: .26667rem;
    margin: 1rem auto;
    text-align: left;
    padding: 5%;
    position: relative;
    overflow: hidden;">
	<div style="font-size: 12px;line-height: 24px;color:#fff">【{{$t('setting.band_name')}}】{{this.bankInfo.bankinfo}}</div><div style="font-size: 12px;line-height: 24px;color:#fff">【{{$t('setting.band_account')}}】{{this.bankInfo.bankid}}</div>
	<div style="font-size: 12px;line-height: 24px;color:#fff">【{{$t('setting.branch_name')}}】{{this.bankInfo.bankfenhang}}</div><div style="font-size: 12px;line-height: 24px;color:#fff">【{{$t('setting.branch_code')}}】{{this.bankInfo.fhnumber}}</div><div style="font-size: 14px;line-height: 32px;color:#fff">【{{$t('setting.username')}}】{{this.bankInfo.username}}<span data-v-66436a76="" style="position: absolute;
    right: .66667rem;
    bottom: .66667rem;
	top:5px;
    color: #000;
    z-index: 9;">{{$t("setting.bindinged")}}</span></div>
	<div  style="margin: 2vw 2vw;
    font-size: 3.333vw;
    color: #333;">{{$t("setting.bind_bank_tip")}}</div>
	</div><div class="wrapper" style="display: none;">
      <div class="add-card" @click="toBindCard()" v-if="!is_bind">
        <van-icon name="plus" />
        <span>{{$t("setting.add_bank")}}</span>
      </div>
      <div class="bank" v-else>
          <div class="info">
<div class="row-content">{{this.bankInfo.bankinfo}}</div>
 <div class="row-content">{{this.bankInfo.bankid}}</div>
<div class="row-content">{{this.userInfo.name}}</div>
           
          </div>
      </div>
      <div class="tips">{{$t("setting.bind_bank_tip")}}</div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      is_bind:false,
      bankInfo:{},
      userInfo:{}
    };
  },
  methods: {
    back(){
      this.$router.push({path:'/Mine'});
    },
    getUserBankInfo(){
      this.$http({
        method: 'get',
        url: 'user_get_bank'
      }).then(res=>{
        if(res.code === 200){
          if(res.data.is_bank){
            this.is_bind = true;
            this.bankInfo = res.data.info;
          }else {
            this.is_bind = false;this.$router.push({path:'/BindCard'});
          }
        }else if(res.code ===401){
          this.$toast(res.msg);
        }
      })
    },
    getUserInfo(){
      this.$http({
        method: 'get',
        url: 'user_info'
      }).then(res=>{
        if(res.code === 200){
          this.userInfo = res.data;
          this.name = res.data.name;
        }else if(res.code ===401){
          this.$toast(res.msg);
        }
      })
    },
    toBindCard() {
      if (!this.userInfo.name) {
        this.$router.push("Setname");
        this.$toast(this.$t("setting.set_name_bank"));
        return true;
      } else if (!this.userInfo.paypassword) {
        
        // this.$router.push("SetPayPassword");
        this.$router.push({path:'/BindCard'})
        // this.$toast(this.$t("setting.set_pwd_bank"));
        return true;
      } else {
        this.$router.push({path:'/BindCard'})
      }
    }
  },
  created() {
    if(!localStorage.getItem('token')){
      this.$router.push({path:'/Login'})
    }else {
      this.getUserInfo();
      this.getUserBankInfo();
    }
  }
};
</script>

<style lang='less' scoped>
@import "../../assets/css/base.css";
.van-cell {
  font-size: 35px;
  line-height: 80px;
}

.container p{
  padding: 0 15px;
  margin-top: 15px;
  font-size: 30px;
  color: #dc2037;
}
.manage-card .wrapper{
  height: calc(100% - 10px);
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
}
.wrapper .add-card{
  display: flex;
  align-items: center;
  justify-content: center;
  color: #000;
  background-color: #fff;
  height: 250px;
}
.wrapper .add-card span{
  margin-left: 10px;
  font-size: 30px;
}
.wrapper .tips {
  margin: 15px 15px;
  font-size: 25px;
  color: #979799;
}
.wrapper .bank .info {
  margin-left: 20px;
  flex: 1;
  color: #000;
}
.wrapper .bank .info .row-content{
  margin: 30px 0;
  line-height: 20px;
  font-size: 30px;
}.nav-bar{background: unset;color:#000}::v-deep  .van-nav-bar__title{color:#000}
</style>
